<template>
    <div v-if="isDynamicAmount">
        <div :class="[$style.formItem]">
            <h4>Amount</h4>
        </div>
        <UiTextField
                v-model="dynamicAmount"
                :value="dynamicAmount"
                type="text"
                :hasError="$isFieldInvalid('dynamicAmount')"
                :errorText="$t('DynamicAmount.dynamicAmountInvalid')"
                @blur="$emit('blur')"
                @focus="$emit('focus')"
                @input="amountChanged"
                id="amount"
        />
    </div>
</template>

<script>

import UiTextField from "@/components/UiTextField.vue";

export default {
  name: 'DynamicAmount',
  components: { UiTextField },
  props: {
    isDynamicAmount: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      dynamicAmount: '$1.00',
      amount_unchanged: true,
    };
  },
  created() {
  },
  validations() {
    return {
      dynamicAmount: {
        unchanged() {
          return !this.amount_unchanged;
        },
      },
    }
  },
  methods: {
    amountChanged(value) {
      const numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 2,
        minimumFractionDigits: 0,
      });

      // Remove any non-numeric characters (except decimal point)
      const numericValue = parseFloat(value.replace(/[^\d.]/g, ''));

      if (isNaN(numericValue)) {
        this.dynamicAmount = '';
        return;
      }

      let roundedValue = Math.round(numericValue * 100) / 100;

      if (roundedValue % 1 === 0) {
        roundedValue = Math.round(roundedValue);
      }

      this.dynamicAmount = numberFormatter.format(roundedValue);
      this.amount_unchanged = false;

      this.$emit('change', roundedValue);
    },
    validate() {
      this.$v.$touch();
      return {
        isValid: !this.$v.$invalid,
      };
    },
  },
};
</script>

<style module lang="scss">
.formItem {
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: relative;

  &._oneLine {
    width: calc(50% - 10px);
  }
}
</style>
